import React, { useEffect, useState } from "react";
import "./index.scss";
import ImgBack from "../../../../assets/images/path18.png";
import ImgBack2 from "../../../../assets/images/path20.png";
import ImgBack3 from "../../../../assets/images/path16.png";
import { getCodeFromUrl } from "../../../../utils/helper";
import { api_strapi } from "../../../../utils/interface";

const HomeBanner = () => {
  const [img, setImg] = useState("");
  const agCode = getCodeFromUrl();

  useEffect(() => {
    const banner = async () => {
      if (agCode) {
        const response = await api_strapi.get(
          `/homes?filters[slug][$eq]=${agCode}&populate=banner.banner_imgs`
        );

        if (response && response.status === 200) {
          const bannerImg =
            response?.data?.data?.[0]?.attributes?.banner?.banner_imgs?.data?.[0]
              ?.attributes?.url;
          if (bannerImg) {
            setImg(bannerImg);
          }
        }
      }
    };
    banner();
  }, [agCode]);

  return (
    <div className="home--content__banner">
      <div className="background-img1">
        <img src={ImgBack} alt="Shadow1" />
      </div>
      <div className="background-img2">
        <img src={ImgBack2} alt="Shadow2" />
      </div>
      <div className="background-img3">
        <img src={ImgBack3} alt="Shadow3" />
      </div>
      <div className="home--banner--container">
        <div className="banner-image">
          <img src={img} alt="text" />
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
